import { render, staticRenderFns } from "./ProductMultipleImageUpload.vue?vue&type=template&id=160e56d8&scoped=true"
import script from "./ProductMultipleImageUpload.vue?vue&type=script&lang=js"
export * from "./ProductMultipleImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ProductMultipleImageUpload.vue?vue&type=style&index=0&id=160e56d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e56d8",
  null
  
)

export default component.exports